import Kindergartengrade_k from './kindergartengrade_k';
import Kindergartengrade_k_subjects from './kindergartengrade_k_subjects';
const Kindergartengrade_keng = () => {
  return (
    <div>
      <Kindergartengrade_k />
    <Kindergartengrade_k_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>English section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Kindergartengrade_keng;